import styled from "styled-components";
import Colors from "../../Constant/Colors";
import { FONTS, STYLES } from "../../Constant/Theme";

export const Container = styled.div`
  height: 87%;
  width: 99%;
  min-width: 240px;
  margin-top: 10px;
  box-sizing: border-box;
  overflow: scroll;
  /* ${(props) => props.reqList && STYLES.borderShadow}; */
  box-shadow: ${(props) => (!props.reqList ? "1px 3px 10px 1px #6665" : "")};

  &:-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
`;

export const StudentList = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 600px;
  margin: 10px 0px;
  ${STYLES.HorizontalLeftAlign}
`;

export const EachColumn = styled.div`
  width: 20%;
  min-width: 120px;
  justify-content: flex-start;
  overflow-x: scroll;
  &:-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  margin-right: 5px;
`;
export const StatusDiv = styled.section`
  /* width: 50%; */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid
    ${(props) =>
      props?.status || props.reqList ? Colors.primary : Colors.brown};
  box-sizing: border-box;
  height: 25px;
  background-color: ${(props) =>
    props?.status || props.reqList
      ? "RGBA(1, 122, 115, 0.15)"
      : "rgba(122, 1, 23, 0.15)"};
  width: ${(props) => (props?.reqList ? "100px" : "65px")};
  p {
    ${FONTS.SemiBold10};
    color: ${(props) =>
      props?.status || props.reqList ? Colors.primary : Colors.brown};
  }
`;
